import React, { Component, createRef } from "react";
import "component/listItem/CategoryType7/styles.scss";
import bannerDefault from "assets/images/bannerDefault.png";
import { PlayDesktopIcon } from "component/icons";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { jackpotCurrencyFormatter } from "utils/currencyHelper";
import { getTotalPool } from "utils/getTotalpool";
import { setDefaultImageFormat } from "utils/image";
import { is } from "immutable";

const ICON_DEFAULT = "ICON_DEFAULT";

class CategoryType7 extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.mainComponent = createRef();

    this.state = {
      hovered: false,
      jackpot: null,
      isVisible: false,
      jackpotPool: null,
    };
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  componentDidMount() {
    this.initObserver();
  }

  componentDidUpdate(prevProps) {
    if (!is(prevProps.game, this.props.game) && this.props.game) {
      let { game } = this.props;
      let jackpot;
      let hasPromotionIcons = false;
      let gameDetailsWidth;

      try {
        jackpot = jackpotCurrencyFormatter(game.get("jackpotBalance"), {
          currency: this.props.currency,
        });
      } catch (err) {}

      try {
        hasPromotionIcons =
          game.get("hasFreeRounds") ||
          game.get("partOfOnGoingTournament") ||
          game.get("isFeatured") ||
          game.get("isJackpot");
      } catch (err) {}

      try {
        if (
          (game.get("hasFreeRounds") && game.get("partOfOnGoingTournament")) ||
          (game.get("hasFreeRounds") && game.get("isFeatured")) ||
          (game.get("isFeatured") && game.get("partOfOnGoingTournament"))
        ) {
          gameDetailsWidth = "pr-2";
        } else if (
          game.get("hasFreeRounds") &&
          game.get("partOfOnGoingTournament") &&
          game.get("isFeatured")
        ) {
          gameDetailsWidth = "pr-3";
        } else {
          gameDetailsWidth = "pr-1";
        }
      } catch (err) {}

      this.setState({
        jackpot,
        hasPromotionIcons,
        gameDetailsWidth,
      });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }

    if (nextProps.game && nextProps.game !== this.props.game) {
      let jackpot;
      let imgSrc = `${nextProps.game.getIn([
        "images",
        "bannerUrl",
      ])}&width=180&theme=dark`;

      if (nextProps.game.get("jackpotBalance")) {
        jackpot = jackpotCurrencyFormatter(
          nextProps.game.get("jackpotBalance"),
          {
            currency: this.props.currency,
            symbol: this.props.symbol,
          }
        );
      }

      this.setState({
        imgSrc: imgSrc,
        jackpot: jackpot,
      });
    }
  }

  render() {
    let { game } = this.props;

    return (
      <div
        className={`${this.props.className} category-type-7`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick(this.props.linkDetails.get("rel"));
          }
          event.stopPropagation();
        }}
        ref={this.mainComponent}
      >
        <div>
          <div className="img-holder">
            {game && this.state.isVisible && (
              <img
                src={`${setDefaultImageFormat(
                  game.getIn(["images", "bannerUrl"]) + "&width=250&theme=dark",
                  this.props.imageFormat.get("banner")
                )}`}
                className="icon d-none"
                alt={game.get("name")}
                onLoad={({ currentTarget }) => {
                  currentTarget.classList.remove("d-none");
                  this.refs[ICON_DEFAULT].classList.add("d-none");
                }}
              />
            )}
            <img
              ref={ICON_DEFAULT}
              src={bannerDefault}
              className="icon"
              alt="banner"
            />
            <div className="jackpot-amount">
              {game && game.get("jackpotBalance") && (
                <span>
                  {this.getTotalPool(this.state.jackpotPool, game, false)}
                </span>
              )}
            </div>
            {!this.props.isOneClickPlayEnabled && (
              <div
                className={`actions w-100 h-100 justify-content-center align-items-center ${
                  this.state.hovered ? "d-flex" : "d-none"
                }`}
              >
                {this.props.linkReal && (
                  <div
                    className="play-button text-center"
                    onClick={(event) => {
                      if (this.props.onClick) {
                        this.props.onClick(this.props.linkReal.get("rel"));
                      }
                      event.stopPropagation();
                    }}
                  >
                    <PlayDesktopIcon />
                  </div>
                )}
                {this.props.linkDemo && (
                  <button
                    className="demo-button btn btn-secondary btn-xs"
                    onClick={(event) => {
                      if (this.props.onClick) {
                        this.props.onClick(this.props.linkDemo.get("rel"));
                      }
                      event.stopPropagation();
                    }}
                  >
                    {this.props.linkDemo.get("name")}
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="details">
            <div className="name">
              {game && <span>{game.get("name")}</span>}
              {!game && <span className="dummy">XXXXXXXXXX</span>}
            </div>
            <div className="provider">
              {game && <span>{game.get("provider")}</span>}
              {!game && <span className="dummy">XXXXXXXXXX</span>}
            </div>
            <div className={`game-type ${this.state.gameDetailsWidth}`}>
              {game && <span>{game.get("gameType")}</span>}
              {!game && <span className="dummy">XXXXXXXXXX</span>}
            </div>
          </div>
          {game && (
            <div className="game-feature">
              {game.get("hasFreeRounds") && (
                <div className="game-feature-badge ribbonIcon">
                  <RibbonIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
              {game.get("partOfOnGoingTournament") && (
                <div className="game-feature-badge trophyIcon">
                  <TrophyIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
              {game.get("isJackpot") && (
                <div className="game-feature-badge jackpotIcon">
                  <CrownIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
              {game.get("isFeatured") && (
                <div className="game-feature-badge editorsChoiceIcon">
                  <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
            </div>
          )}
          {game && !game.get("gameType") && (
            <div className="spacer">
              <>&nbsp;</>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CategoryType7;
